<template>
  <q-page :style="cssVars">
    <div class="q-pa-md">
      <div class="row q-mb-md justify-between">
        <div>
          <div class="page-title">
            <span class="text-primary q-mr-sm"> Your </span>
            Workspace DASHBOARD
          </div>
        </div>
        <!-- <div>
          <q-img
            :src="getOutcomeImage(selectedOutcome)"
            class="q-mx-auto"
            style="width: 36px; height: 36px"
            v-ripple
          ></q-img>
        </div> -->
      </div>
      <div class="row q-col-gutter-x-md">
        <div class="col-7">
          <q-card class="shadow-10 full-height">
            <q-card-section class="bg-accent card-header text-white">
              Please select an Outcome
            </q-card-section>
            <div
              class="row justify-center"
              style="margin-top: 40px; padding-left: 60px; padding-right: 60px"
            >
              <div class="col-12">
                <div class="row text-center q-col-gutter-xl">
                  <div
                    class="col-3"
                    v-for="(outcome, i) in list"
                    :key="i"
                    :name="outcome.name"
                  >
                    <q-img
                      :src="getOutcomeImage(outcome)"
                      class="q-mx-auto"
                      style="border-radius: 96px; width: 96px; height: 96px"
                      v-ripple
                      @click="selectOutcome(outcome)"
                    ></q-img>
                    <br />
                    <span
                      class="outcome-title"
                      :style="`color: ${outcome.primaryColor}`"
                      >{{ outcome.label }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </q-card>
        </div>
        <div class="col-5">
          <q-card class="shadow-10">
            <q-card-section class="bg-accent card-header text-white">
              Your {{ selectedOutcome.label }} Overview
            </q-card-section>
            <q-card-section class="q-py-none">
              <div class="row">
                <div style="width: 100%; max-width: 220px; margin-top: 20px">
                  <span class="overview-heading" v-if="selectedOutcome">
                    Your Total Carbon Emissions (tCO2e)
                  </span>
                  <br />
                  <span class="total-emissions"> 215.17 (tCO2e) </span>
                  <br />
                  <span class="year"> 2021 </span>
                  <br />
                  <br />
                  <span class="year">You Aim</span>
                  <br />
                  <span class="overview-heading"
                    >to reduce by: <span class="year"> 4% </span>
                  </span>
                  <br />
                  <span class="overview-heading"
                    >by the end of
                    <span class="year"> {{ $moment().format("YYYY") }} </span>
                  </span>
                </div>

                <div
                  v-if="selectedOutcome"
                  class="col"
                  style="max-width: 300px;!important; margin: auto"
                >
                  <div class="full-width" ref="progressCircle">
                    <q-circular-progress
                      show-value
                      :value="30"
                      :size="width - 30 + 'px'"
                      :thickness="0.22"
                      :style="`color:${cssVars['--outcome-primary']};`"
                      track-color="grey-3"
                      class="q-ma-md"
                    >
                      <q-avatar :size="width - width * 0.55 + 'px'">
                        <q-img
                          :src="getOutcomeImage(selectedOutcome)"
                          class="q-mx-auto"
                          style="width: 100%; height: 100%"
                        ></q-img>
                      </q-avatar>
                    </q-circular-progress>
                  </div>
                </div>
              </div>
            </q-card-section>

            <div class="row justify-between q-px-md">
              <div class="self-start">
                <span class="overview-heading">
                  Carbon Emission Target Projection
                </span>
                <br />
                <span class="total-emissions">
                  206.56 (tCO2e) by
                  <span class="year">by {{ $moment().format("YYYY") }}</span>
                </span>
                <br />
                <br />
                <span class="overview-heading"> You have Completed </span>
                <br />
                <span class="solution-text text-primary">
                  6 <span class="text-accent"> Solutions </span></span
                ><br />
                <span class="overview-heading"> For this Source </span>
              </div>
            </div>
            <q-card-actions vertical align="right">
              <q-btn class="bg-primary text-white button-style" no-caps>
                View Summary Outcome
              </q-btn>
              <q-btn
                class="bg-accent text-white button-style"
                no-caps
                @click="goToWorkspace"
              >
                Go to
                {{ selectedOutcome ? selectedOutcome.label : "" }}
                Workspace
              </q-btn>
            </q-card-actions>
          </q-card>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import { getOutcomeImage } from "@/functions/getOutcomeImage";
export default {
  computed: {
    ...mapGetters({
      list: "outcomes/list",
    }),
    cssVars() {
      if (this.selectedOutcome) {
        let primaryColorFaded = this.selectedOutcome.primaryColor
          ? this.selectedOutcome.primaryColor.split("#")
          : ["", "162c47"];
        let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";
        return {
          "--outcome-primary": this.selectedOutcome.primaryColor
            ? this.selectedOutcome.primaryColor
            : "#162c47",
          "--outcome-secondary": this.selectedOutcome.secondaryColor
            ? this.selectedOutcome.secondaryColor
            : "#162c47",
          "--outcome-tertiary": this.selectedOutcome.tertiaryColor
            ? this.selectedOutcome.tertiaryColor
            : "#162c47",
          "--outcome-primary-faded": primaryColorFadedString,
        };
      } else {
        return "grey";
      }
    },
  },
  data: () => ({
    selectedOutcome: null,
    progressCircleSize: 1,
    width: 0,
  }),
  created() {
    window.addEventListener("resize", this.calculateCircleSize);
  },
  destroyed() {
    window.removeEventListener("resize", this.calculateCircleSize);
  },

  mounted() {
    this.$store.dispatch("outcomes/loadAll").then(() => {
      this.selectOutcome(this.list[0]);
    });

    setTimeout(() => {
      this.calculateCircleSize();
    }, 500);
  },
  methods: {
    getOutcomeImage: getOutcomeImage,
    selectOutcome(outcome) {
      this.selectedOutcome = outcome;
    },
    calculateCircleSize() {
      this.width = this.$refs.progressCircle.clientWidth;
    },
    goToWorkspace() {
      this.$router.push("/workspace/" + this.selectedOutcome.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
}

.card-header {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */

  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
}

.button-style {
  height: 34px;
  width: 151px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
  line-height: 11px;
}

.overview-heading {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 11px;
  line-height: 13px;
}

.total-emissions {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 900;
  font-size: 24px;
  line-height: 29px;
}

.year {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 20px;
  color: #4ac7e9;
}

.solution-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 900;
  font-size: 24px;
  line-height: 29px;
}

.outcome-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
}
</style>
